import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "../../config/config";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const MyPayPalOrderButton = ({ currency, price, handleSubmit, paymentType, paymentId ,type}) => {
  console.log("🚀 ~ MyPayPalOrderButton ~ currency:", currency)
  const { t } = useTranslation()
  const initialOptions = {
    "client-id": PAYPAL_CLIENT_ID,
    "enable-funding": "card",
    "disable-funding": "paylater,venmo",
    "data-sdk-integration-source": "integrationbuilder_sc",
    "currency": currency
  };
  const [message, setMessage] = useState({ status: true, reason: "", text: "" });
  const createOrder = ApiHook.CallCreatePaypalOrder()
  const captureOrder = ApiHook.CallCapturePaypalOrder()
const handleCreateOrder = async () => {
  try {
    const response = await createOrder.mutateAsync({ amount: price, type });
    if (response?.status) {
      return response.data;
    } else {
      toast.error(response?.message ||response.description || 'Failed to create order');
      return false;
    }
  } catch (error) {
    toast.error(error?.message || 'Create order failed');
    return false;
  }
};

const handleCaptureOrder = async (orderId) => {
  try {
    const response = await captureOrder.mutateAsync({ orderId });
    if (response?.status) {
      return response.data;
    } else {
      toast.error(response?.message || 'Failed to capture order');
      return false;
    }
  } catch (error) {
    toast.error(error?.message || 'Capture order failed');
    return false;
  }
};
  const handleOrderApproval = (data, actions, transaction) => {
    if (data.orderID) {
      data['transaction'] = transaction
      data['transactionId'] = transaction?.id
      handleSubmit(paymentId, undefined, paymentType, data);
    }
  };

  function Message({ content }) {
    return <p className='paypal-response-msg' style={{ color: content.status ? "#0d6f0d" : "#b90000" }}>{t(content.text, { msg: content.msg })}</p>;
  }



  return (
    <div>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{
            shape: "rect",
            layout: "vertical",
          }}
          createOrder={async () => {
            try {
              const orderData = await handleCreateOrder()
              if (!orderData) throw new Error("Internal Server Error")
              if (orderData.id) {
                return orderData.id;
              } else {
                const errorDetail = orderData?.details?.[0];
                const errorMessage = errorDetail
                  ? `${errorDetail.issue} ${errorDetail.description} '${orderData.debug_id}'`
                  : JSON.stringify(orderData);

                throw new Error(errorMessage);
              }
            } catch (error) {
              setMessage({ ...message, status: false, msg: error, text: "initiateCheckoutFailed" });
            }
          }}
          onApprove={async (data, actions) => {
            try {
              const orderData = await handleCaptureOrder(data.orderID)
              if (!orderData) throw new Error("Internal Server Error")
              const errorDetail = orderData?.details?.[0];
              if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                return actions.restart();
              } else if (errorDetail) {
                throw new Error(`${errorDetail.description} '${orderData.debug_id}'`);
              } else {
                const transaction = orderData.purchase_units[0].payments.captures[0];
                setMessage({ ...message, status: true, text: "transactionComplete", msg: transaction.id });
                handleOrderApproval(data, actions, transaction)
              }
            } catch (error) {
              setMessage({ ...message, status: false, msg: error, text: "transactionNotProcessed" });
            }
          }}
          onError={(error) => setMessage({ ...message, status: false, msg: error, text: "cannot load paypal" })}
        />
      </PayPalScriptProvider>
      <Message content={message} />
    </div>
  );
};

export default MyPayPalOrderButton;
